import React from "react"
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import styles from "./Button.css"

function Button(props) {
  return (
    <>
      {!props.isLoading && (
        <button type="button"
          style={props.buttonStyle}
          className={`${styles.button__content_submit} ${props.disabled ? styles.submit_disabled : ''} ${props.className || ""} `}
          onClick={(e) => props.handleOnClick && props.handleOnClick(e)}
          disabled={props.disabled}
        >
          {props.name}
        </button>
      )}
      {props.isLoading && (
        <button type="button"
          style={props.buttonStyle}
          className={`${styles.button__content_submit} ${styles.submit_disabled} ${props.className}`}>
          <div className={styles.loading__page}>
            {/* {locale['sign_in']} */}
            <div className={styles.loading__ring}>
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        </button>
      )}
    </>
  )
}

export default withStyles(styles)(Button)